import React, { FormEvent } from "react";
import {
  FastForward,
  FastRewind,
  Pause,
  PlayArrow,
  // SkipNext,
  VolumeUp,
  VolumeOff,
  RestartAlt
} from "@mui/icons-material";
import "./ExerciseControl.css";
import "react-video-seek-slider/styles.css"
import ReactPlayer from "react-player";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTableCellsLarge } from '@fortawesome/free-solid-svg-icons';

interface ExerciseControlProps {
  onPlayPause: () => void;
  playing: boolean;
  fastForward: () => void;
  rewind: () => void;
  restart: () => void;
  switchPlayerToGrid: (videoRef: React.RefObject<ReactPlayer>) => void;
  muteControl: () => void;
  muted: boolean;
  currentTime: number;
  handleSeekChange: (event : FormEvent<HTMLInputElement>) => void;
  handleVolumeChange: (event : { target: { value: number; };}) => void;
  volume: number;
  videoRef: React.RefObject<ReactPlayer>
  grid: boolean;
}

function ExerciseControl({
  onPlayPause,
  playing,
  fastForward,
  rewind,
  restart,
  switchPlayerToGrid,
  muteControl,
  muted,
  currentTime,
  handleSeekChange,
  handleVolumeChange,
  volume,
  videoRef,
  grid
} : ExerciseControlProps) {

  return (
    <div>
      <div className="progress-bar">
        <input
          type='range' 
          min={0}
          max={videoRef.current?.getDuration()}
          value={currentTime}
          onInput={(e) => handleSeekChange(e)}
          step={0.1}
        />
      </div>
    <div className="controls-container">
      <div className="controls-left">
          <div className="button-wide" onClick={restart}>
            <RestartAlt className="medium-icon" fontSize="large" />
          </div>
          {grid ? '' : 
          <div className="button-wide" onClick={() => switchPlayerToGrid(videoRef)}>
               <FontAwesomeIcon
                className="medium-icon downshift"
                icon={faTableCellsLarge}
                size='2x'
              />
            </div>
          }
      </div>
      <div className="controls-middle">
          <div className="button-wide" onClick={rewind}>
            <FastRewind className="medium-icon" fontSize="large" />
          </div>
          <div className="button-wide" onClick={onPlayPause}>
            {playing ? 
            <Pause className="medium-icon" fontSize="large" />
            :
            <PlayArrow className="medium-icon" fontSize="large" />}
          </div>

          <div className="button-wide" onClick={fastForward}>
            <FastForward
              className="medium-icon"
              fontSize="large"
            />
          </div>
      </div>
      <div className="controls-right">
        {/* <div className="volume-bar">
          <input
            style={{width: "100%", color: 'black'}}
            type='range' 
            min={0}
            max={1}
            value={volume}
            onInput={(e) => handleVolumeChange(e)}
            step={0.05}
          />
        </div> */}
        <div className="mute" style={{color: muted ? 'red': 'white'}}>
          {muted ? 
          <VolumeOff
            className="large-square-icon"
            fontSize="large"
            onClick={muteControl}
          />
          :
          <VolumeUp
            className="large-square-icon"
            fontSize="large"
            onClick={muteControl}
          />
          }
        </div>
      </div>
    </div>
      </div>
  );
}

export default ExerciseControl;
